import { DriversClient } from '@src/driver/services/DriversClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface Props {
  clientId: string;
  driverId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useDeleteDriver = ({
  clientId,
  driverId,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      await DriversClient.delete(clientId, driverId);
    },
    onSuccess: async () => {
      onSuccess();
      await queryClient.invalidateQueries({
        queryKey: ['drivers.list', clientId],
      });
    },
    onError,
  });

  return {
    deleteDriver: mutate,
    isLoading: isPending,
  };
};
